export const tags = [
    {name: 'Имя пациента', tag: '{PatientName}'},
    {
        name: 'Баллы пациента (После числа пишется слово "балл" в правильном склонении (например: 133 балла, 136 баллов))',
        tag: '{PatientPointsCount}',
    },
    {
        name: 'Начисляемые баллы за регистрацию (После числа пишется слово "балл" в правильном склонении (например: 133 балла, 136 баллов))',
        tag: '{PointsForRegistration}',
    },
    {
        name: 'Начисляемые баллы за рекомендацию (После числа пишется слово "балл" в правильном склонении (например: 133 балла, 136 баллов))',
        tag: '{PointsForRecommendation}',
    },
    {
        name: 'Начисляемые баллы за отзыв (После числа пишется слово "балл" в правильном склонении (например: 133 балла, 136 баллов))',
        tag: '{PointsForReview}',
    },
    {
        name: 'Начисляемые баллы на день рождения (После числа пишется слово "балл" в правильном склонении (например: 133 балла, 136 баллов))',
        tag: '{PointsForBirthday}',
    },
    {
        name: 'Ссылка на Онлайн запись',
        tag: '{AppointmentLink}',
    },
    {name: 'Название клиники', tag: '{ClinicName}'},
    {
        name: 'Время работы клиники с',
        tag: '{ClinicWorkTimeFrom}',
    },
    {
        name: 'Время работы клиники по',
        tag: '{ClinicWorkTimeTo}',
    },
    {
        name: 'Количество начисляемых или списываемых баллов (После числа пишется слово "балл" в правильном склонении (например: 133 балла, 136 баллов))',
        tag: '{PointsToAddOrWithDraw}',
    }, //начисляемые и списываемые баллы
    {
        name: 'Баллы пациента которые могут сгореть (После числа пишется слово "балл" в правильном склонении (например: 133 балла, 136 баллов))',
        tag: '{PointsToBurn}',
    },
    {
        name: 'Ссылка на оставление отзыва на клинику',
        tag: '{BranchReviewLink}',
    }, //ссылка на филиала в отзовике
    {
        name: 'Ссылка на оставление отзыва на врача',
        tag: '{DoctorReviewLink}',
    },
    {
        name: 'Количество дней от даты сгорания баллов до уведомления о сгорании баллов (После числа пишется слово "день" в правильном склонении (например: 133 дня, 136 дней))',
        tag: '{DaysToNoticeAboutBurning}',
    },
    {
        name: 'Количество дней для сгорания баллов (После числа пишется слово "день" в правильном склонении (например: 133 дня, 136 дней))',
        tag: '{DaysBeforeBurning}',
    },
    {
        name: 'Количество дней до дня рождения (После числа пишется слово "день" в правильном склонении (например: 133 дня, 136 дней))',
        tag: '{DaysBeforeBirthday}',
    },
    {
        name: 'Количество начислений баллов из настроек клиники',
        tag: '{PointsChargesCount}',
    },
    {
        name: 'Начисляемые баллы за каждую оплату счета приглашенным пациентом',
        tag: '{PointsFixForPay}',
    },
    {
        name: 'Начисляемый процент от счета в виде баллов за каждую оплату счета приглашенным пациентом',
        tag: '{PointsPercentForPay}',
    },
    {
        name: 'Количество начислений, оставшихся у пациента на этот месяц',
        tag: '{UserPointsChargesCount}',
    },
];

